import { useEffect, useMemo } from 'react'

import { useV3Protocol } from './subgraph/v3'

// to deal with the outlier data in the subgraph, when a swap is made on a very low liquidity pool
const OUTLIER_THRESHOLD = 1e12

export function useProtocolDataV3() {
  const { data, isLoading, error, refetch } = useV3Protocol()

  // const { setProtocolData, setLoading } = useSetProtocolDataV3()

  useEffect(() => {
    if (error) {
      console.error('Error fetching Protocol Data V3:', error)
    }
  }, [error])

  const tvlUSD = useMemo(() => data?.totalValueLockedUSD, [data?.totalValueLockedUSD])
  const totalVolumeUSD = useMemo(() => data?.totalVolumeUSD, [data?.totalVolumeUSD])

  const formattedData = {
    tvlUSD,
    totalVolumeUSD,
  }

  return {
    isLoading,
    data: formattedData,
    isError: !!error,
    refetch,
  }
}
